"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCapitalize = function (value) {
    return value[0].toUpperCase() + value.slice(1);
};
